import { File } from "../types";

type DownloadableDriveFile = Pick<File, "name" | "url">;

export async function downloadDriveFile(
  file: DownloadableDriveFile,
): Promise<void> {
  const fileUrl = file.url?.trim();

  if (!fileUrl) {
    throw new Error("File URL is not available");
  }

  const anchor = document.createElement("a");
  anchor.href = fileUrl;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.style.display = "none";

  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}
